import { createSelector } from '@reduxjs/toolkit';

import { selectAuth } from '../slices/auth';

export const authUser = createSelector(selectAuth, auth => auth.data?.authInfo ?? null);
